import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
// import VirtualList from 'preact-virtual-list';

import PubSub, { topics } from '../../lib/pubsub';
import Input from '../form/input';
import CategoryTree from './tree';
import CategoryNav from './nav';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    height: 100,
    windowHeight: 0,
    loading: false,
    view: {
        brands: false,
        languages: false,
        products: false,
    },
};

function DescriptionIcon(props) {
    return (
        <i
            className={`mr-1 ${props.icon}
                text-${props.value ? 'success' : 'secondary'}`}
            title={props.value ? props.text : `No ${props.text}`}
        />
    );
}

function getAvailabilityBadge(availability) {
    const avail = `${availability}`;
    if (avail.match(/yes/i)) {
        return 'success';
    }
    if (avail.match(/^\d+\+?$/i)) {
        return 'success';
    }
    if (avail.match(/\d{2}\.\d{2}/)) {
        return 'warning';
    }
    return 'danger';
}

const reducer = (accumulator, current) => accumulator + current[1];

@observer
class ProductTableLine extends Component {
    imageServer = util.getImageServer();

    updateLineField = (e) => {
        // console.log('updateLineField:', e);
        const { updateField } = this.props;
        const { params } = e.target.dataset;
        const inputParams = JSON.parse(params || {});
        const { id, field } = inputParams;
        const { value } = e.target;
        updateField(id, field, value);
    }

    saveLineField = (e) => {
        // console.log('saveField:', e);
        const { saveField } = this.props;
        const { params } = e.target.dataset;
        const inputParams = JSON.parse(params || {});
        const {
            id, field, updatememory, value,
        } = inputParams;
        saveField(id, field, value, updatememory);
    }

    render() {
        const { product, saved } = this.props;
        return (
            <tr class={`${style.tableline}`}>
                <td>
                    <div class='mb-1'>
                        {product.articleno}
                    </div>

                    {/* {product.imgs && product.imgs[1] && product.imgs[1].color && <div
                        class='rounded-circle border float-left mr-1 mt-1'
                        style={`background-color: rgb(${product.imgs[1].color[0]}, ${product.imgs[1].color[1]}, ${product.imgs[1].color[2]}); width: 25px; height: 25px;`}
                    >&nbsp;</div>}

                    {product.imgs && product.imgs[1] && product.imgs[1].palette && product.imgs[1].palette.map(col => <div
                        class='rounded-circle border float-left mr-1 mt-1'
                        style={`background-color: rgb(${col[0]}, ${col[1]}, ${col[2]}); width: 15px; height: 15px;`}
                    >&nbsp;</div>)} */}

                </td>
                <td class='text-center'>
                    <a href={`/products/${encodeURIComponent(product.articleno)}/Basics`}>
                        {product.images.small && <img class='rounded' src={product.images.small} />}
                    </a>

                    <div>
                        {product.imgs && Object.keys(product.imgs).filter(i => i > 1).map(imgKey => <span>
                            <img
                                class='rounded mr-1'
                                src={`${this.imageServer}/${util.getImageSrc(product.imgs[imgKey], '80x80', imgKey)}`}
                                style={`height: 20px; max-width: 20px;`}
                            />
                        </span>)}
                    </div>
                </td>
                <td>
                    <a href={`/products/${encodeURIComponent(product.articleno)}/Basics`}>
                        {product.nameDisplay}<br />
                    </a>
                    {Object.keys(product.translations || {}).filter(e => e.length === 2).map(lang => (
                        <small className={`ml-2 text-muted font-weight-lighter`}>
                            <i class='fas fa-globe-europe' /> {lang}
                            {Object.keys(product.translations[lang] || {}).map(field => (
                                <span>
                                    {Object.keys(product.translations[lang][field].suggestions || {}).map(suggestion => (
                                        <span class='text-danger ml-1'>
                                            {field}: {suggestion}
                                        </span>
                                    ))}
                                </span>
                            ))}
                        </small>
                    ))}
                    {product.avg > 0 && <div>
                        <small className={`ml-2 text-warning font-weight-lighter`}>
                            {[1, 2, 3, 4, 5].map(score => (
                                <i class={`${product.avg >= score ? 'fas' : 'far'} fa-star`} />
                            ))} ({product.avgTot})
                        </small>
                    </div>}
                    <div>
                        <small>
                            {product.introYear}
                        </small>
                    </div>
                </td>
                <td>
                    <small class='float-right'>
                        <span
                            className={`mr-1 badge
                                badge-${product.showonwebyesno === 1 ? 'success' : 'danger'}`}
                            title='DealerWeb'>
                            DW
                        </span>
                        <span
                            className={`mr-1 badge
                                badge-${product.showOnConsumerWeb === 1 ? 'success' : 'danger'}`}
                            title='ConsumerWeb'>
                            CW
                        </span>
                        {product.is_new ? <span className={`mr-1 badge badge-primary`}>
                            New
                        </span> : ''}
                        {product.preSale ? <span className={`mr-1 badge badge-secondary`}>
                            PS
                        </span> : ''}
                        {product.is_discontinued && <span className={`mr-1 badge badge-warning`}>
                            Discontinued
                        </span>}
                    </small>
                    <a href={`/products/${encodeURIComponent(product.articleno)}/Basics`}>
                        {product.name}<br />
                    </a>

                    <span class='float-right'>
                        <small className='text-muted'>{product.dealerCurrency}</small>
                        {'\u00A0'}<nobr>{util.format(product.dealerPrice, 2, ',', ' ')}</nobr>
                    </span>

                    <small>
                        <span className='text-primary'>{product.mainCategory}</span>
                        <span className='text-success'>
                            {product.intermediateCategory ? ` / ${product.intermediateCategory}` : ''}
                        </span>
                        <span className='text-danger'>
                            {product.subCategory ? ` / ${product.subCategory}` : ''}
                        </span>
                        <br />
                        <span class='float-right'>
                            Retail price: 
                            <small className='text-muted ml-2'>{product.retailCurrency}</small>
                            {'\u00A0'}<nobr>{util.format(product.retailPrice, 2, ',', ' ')}</nobr>
                        </span>
                        <span className='text-muted'>
                            <DescriptionIcon
                                icon='fas fa-info-circle'
                                value={product.description}
                                text='Description'
                            />
                            <DescriptionIcon
                                icon='fas fa-tools'
                                value={product.features}
                                text='Features'
                            />
                            <DescriptionIcon
                                icon='fas fa-robot'
                                value={product.tech}
                                text='Tech'
                            />
                            <DescriptionIcon
                                icon='fas fa-stethoscope'
                                value={product.care}
                                text='Care'
                            />
                            <DescriptionIcon
                                icon='fas fa-people-carry'
                                value={product.howtouse}
                                text='How-to-use'
                            />
                            <DescriptionIcon
                                icon='fab fa-youtube'
                                value={product.youtubeEUR}
                                text='Youtube'
                            />
                        </span>
                    </small>
                </td>
                <td class='text-center'>
                    <span className={`mr-1 badge
                        badge-${getAvailabilityBadge(product.availability)}`}>
                        {product.availability}
                    </span>
                </td>
                <td class='text-right'>
                    {product.unitsInStock}
                    <small>
                        <div class='text-success'>
                            {Array.isArray(product.supplierOrderLines) && <span>
                                {product.supplierOrderLines.reduce(reducer, 0)}
                                <i class='fas fa-sign-in-alt ml-1' />
                            </span>}
                        </div>
                        <div class='text-danger'>
                            {Array.isArray(product.customerOrderLines) && <span>
                                {product.customerOrderLines.reduce(reducer, 0)}
                                <i class='fas fa-sign-out-alt ml-1' />
                            </span>}
                        </div>
                    </small>
                </td>
                <td class='text-right'>
                    <Input
                        id={product.id}
                        className='text-right form-control-sm'
                        isValid={saved[`sort.${product.id}`]}
                        name='sort'
                        value={product.sort}
                        dataParams={JSON.stringify({
                            id: product.id,
                            field: 'sort',
                        })}
                        onInput={this.updateLineField}
                        hideHelp={1}
                    />
                </td>
                <td class='text-center'>
                    <span
                        class={`mr-1 badge ${style.pointerCursor} badge-${product.offline === 1 ? 'success' : 'danger'}`}
                        // onClick={() => saveField(product.id, `offline`, product.offline === 1 ? 0 : 1, true)}
                        data-params={JSON.stringify({
                            id: product.id,
                            field: 'offline',
                            value: product.offline === 1 ? 0 : 1,
                            updatememory: 1,
                        })}
                        onClick={this.saveLineField}
                    >
                        &nbsp;<i class={`fas fa-trash${product.offline === 1 ? '-restore' : ''}`} /> {product.offline === 1 ? 'Restore' : 'Delete'}
                    </span>
                </td>
            </tr>
        );
    }
}

@observer
class ProductTable extends Component {
    render() {
        const { products, saved, saveField, updateField, productStore } = this.props;
        return (
            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                <thead>
                    {productStore.sort !== productStore.defaultSort && <tr>
                        <th colspan='8'>
                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => productStore.resetSort()}>
                                <i class='fas fa-times-circle' /> Reset sort
                            </span>
                        </th>
                    </tr>}
                    <tr>
                        <th style='width: 5%'>
                            <span class={style.pointerCursor} onClick={() => productStore.toggleSort('articleno', '-')}>
                                Article# {util.getSortIcon('articleno', productStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%' class='text-center'>Image</th>
                        <th style='width: 20%'>
                            <span class={style.pointerCursor} onClick={() => productStore.toggleSort('nameDisplay', '')}>
                                NameDisplay {util.getSortIcon('nameDisplay', productStore.sort)}
                            </span>
                        </th>
                        <th style='width: 50%'>
                            <span class={style.pointerCursor} onClick={() => productStore.toggleSort('name', '')}>
                                Name {util.getSortIcon('name', productStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%' class='text-center'>
                            <span class={style.pointerCursor} onClick={() => productStore.toggleSort('availability', '-')}>
                                Availability {util.getSortIcon('availability', productStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%' class='text-right'>
                            <span class={style.pointerCursor} onClick={() => productStore.toggleSort('unitsInStock', '-')}>
                                In stock {util.getSortIcon('unitsInStock', productStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%' class='text-right'>
                            <span class={style.pointerCursor} onClick={() => productStore.toggleSort('sort', '')}>
                                Sort {util.getSortIcon('sort', productStore.sort)}
                            </span>
                        </th>
                        <th style='width: 5%' class='text-center'>
                            <span class={style.pointerCursor} onClick={() => productStore.toggleSort('offline', '-')}>
                                Online {util.getSortIcon('offline', productStore.sort)}
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {products && products.map(product => <ProductTableLine
                        product={product}
                        saved={saved}
                        saveField={saveField}
                        updateField={updateField}
                    />)}
                </tbody>
            </table>
        );
    }
}

@observer
class ProductList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};

        const { productStore } = this.props.stores;
        productStore.load();
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { productStore } = this.props.stores;
        const { totalAppend, limit } = productStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = productStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                productStore.updateOffset(offset);
                await productStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    updateField = async (id, field, value) => {
        const { productStore } = this.props.stores;
        productStore.updateField(id, field, value);

        const timerId = `${field}-${id}`;
        clearTimeout(this.updateTimer[timerId]);
        this.updateTimer[timerId] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { productStore } = this.props.stores;
        await productStore.saveField(id, field, value);
    }

    saveField = async (id, field, value, updatememory) => {
        const { productStore } = this.props.stores;
        productStore.saveField(id, field, value, updatememory);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
        const { loading, height } = this.state;
        const { productStore } = this.props.stores;
        const { products, queryFilter, saved } = productStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <CategoryNav {...this.props} />
                    </div>
                </div>
                <div class='row'>
                    <div class='col-2 fixed-top overflow-auto'
                        style={`margin-top: ${height + 60}px; height: calc(100% - ${height + 60}px);`}
                    >
                        <small>
                            <CategoryTree {...this.props} />
                        </small>
                        <div class='text-center mt-4 mb-2'>
                            <small class='text-muted'>
                                <i class='fas fa-ellipsis-h' />
                            </small>
                        </div>
                    </div>
                    <div class='col-10 offset-2'>
                        <div>

                            {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                                <h1><i class='fas fa-search' /> Search results</h1>
                                Found {productStore.total || 0} results in your search for "{queryFilter.search}".<br />
                                <button class='btn btn-sm btn-warning mt-2'
                                    onClick={() => productStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                                >
                                    <i class='fas fa-times' /> Reset search
                                </button>
                            </div>}

                            <div class='table-responsive'>
                                <ProductTable
                                    products={products}
                                    saved={saved}
                                    saveField={this.saveField}
                                    updateField={this.updateField}
                                    productStore={productStore}
                                />
                            </div>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default ProductList;




// WEBPACK FOOTER //
// ./components/products/list.js